import { useSuspenseQuery, useQueryClient } from '@tanstack/react-query';
import queryKeys from '../../support/uiStateKeys';

const dataKey = queryKeys.SELECTED_LIMITED_USE_PRODUCT;
const defaultSelectedProduct = null;
/**
 * selectedLimitedUseProduct returns the limited use product that the user has selected for purchase.
 *
 * @returns {{ selectedLimitedUseProduct: object, setSelectedLimitedUseProduct: function }}
 */
const useSelectedLimitedUseProduct = () => {
  const queryClient = useQueryClient();

  const { data } = useSuspenseQuery({
    queryKey: [dataKey],
    queryFn: ({ queryKey }) => queryClient.getQueryData(queryKey),
    initialData: defaultSelectedProduct,
  });

  const setSelectedLimitedUseProduct = (selectedProduct) => {
    queryClient.setQueryData([dataKey], selectedProduct);
  };

  return {
    selectedLimitedUseProduct: data,
    setSelectedLimitedUseProduct,
  };
};

export default useSelectedLimitedUseProduct;
